import { Layout } from 'antd'
import React from 'react'
import { Outlet } from 'react-router-dom'
import PublicFooterXS from '../Footer/PublicFooterXS'
import { Color } from '../../../Common/Color'
import TabletPublicHeader from '../Header/Tablet/TabletPublicHeader'

export default function TabletCompleteLayout () {
  return (
    <Layout>
      <TabletPublicHeader withSearch={true} />
      <Layout.Content style={{ overflowY: 'scroll', backgroundColor: Color.white }}>
        <Outlet />
      </Layout.Content>
      <PublicFooterXS />
    </Layout>
  )
}
